<template>
  <div class="timer">
    <div v-if="expired">
      <span class="countdown expired">Cart expired</span>
    </div>
    <div v-else>
      <span>Cart available for&nbsp;</span>
      <strong ref="countdown" :class="`countdown ${expiring ? 'expiring' : ''}`">{{ clockReadout }}</strong>
    </div>
  </div>
</template>

<script>
import { Duration } from 'luxon'
import { mapState, mapMutations, mapActions } from 'vuex'

const CartExpiringPeriod = 300;

export default {
  name: 'Countdown',
  data() {
    return {
      remainingSeconds: null,
      tick: null
    }
  },
  computed: {
    ...mapState({
      steps: state => state.checkout.steps,
      expiresAt: state => state.checkout?.order?.expiresAt ?? state.cart?.shoppingCart?.expiresAt
    }),
    clockReadout() {
      return Duration.fromMillis(this.remainingSeconds * 1000).toFormat('mm:ss')
    },
    expiring() {
      return this.remainingSeconds > 0 && this.remainingSeconds < CartExpiringPeriod;
    },
    expired() {
      return this.remainingSeconds < 1;
    }
  },
  methods: {
    ...mapMutations({
      updateStep: 'checkout/updateStep',
    }),
    ...mapActions({
      setCartExpired: 'cart/setCartExpired'
    }),
    updateClock() {
      this.remainingSeconds = Math.floor((new Date(this.expiresAt) - new Date())/1000) || 0;
    },
    init() {
      if (!this.tick) {
        clearInterval(this.tick)
      }

      if (!this.expiresAt) {
        return;
      }

      this.updateClock();

      this.tick = setInterval(() => {
        this.updateClock();

        if(this.remainingSeconds <= CartExpiringPeriod && this.remainingSeconds % 60 === 0) {
          this.$refs?.countdown?.classList?.toggle('shake');
        }
      }, 1000)
    }
  },
  watch: {
    expired() {
      if (this.expired) {
        clearInterval(this.tick);
        this.setCartExpired(true);
      }
    },
    steps() {
      if (this.steps.confirmation) {
        clearInterval(this.tick)
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>
